<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>分销等级</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form ref="artFrom" :label-width="labelWidth" :label-position="labelPosition" @submit.native.prevent>
                        <Row type="flex">
                            <Col>
                                <Button v-auth="['market/dealer/add']" type="primary" class="bnt" icon="md-add" @click="addLevel">添加等级</Button>
                            </Col>
                        </Row>
                    </Form>
                    <Table class="mt25" :columns="columns" :data="tableData">
                        <template slot-scope="{ row, index }" slot="level_id">
                            {{row.level_id != 'default' ? row.level_id : '默认'}}
                        </template>
                        <template slot-scope="{ row, index }" slot="action">
                            <a @click="edit(row)">编辑</a>
                            <Divider type="vertical" v-if="row.level_id != 'default'"/>
                            <a @click="del(row)" v-if="row.level_id != 'default'">删除</a>
                        </template>
                    </Table>
                </Card>
            </div>
        </div>
        <!-- 添加 编辑表单-->
        <div  v-if="FromData">
            <Modal v-model="modals" scrollable  footer-hide closable :title="FromData_title"  :z-index="1" width="700" @on-cancel="cancel">
                <Form ref="FromData" :model="FromData" :label-width="160">
                    <FormItem label="等级名称" prop="name" :rules="{required: true, message: '请输入等级名称', trigger: 'blur'}">
                        <Input v-model="FromData.name" placeholder=""></Input>
                    </FormItem>
                    <FormItem label="背景图" prop="image">
                        <div class="pictrueBox" @click="modalPicTap('dan', 'danFrom')">
                            <el-upload
                                    class=""
                                    list-type="single-image"
                                    :on-success="(value) => uploadSuccess('image', 'single', value)"
                                    :show-file-list="false"
                                    :action="app_url + '/store/uploader/upload'">
                                <div class="pictrue" v-if="FromData.image">
                                    <img v-lazy="FromData.image" />
                                </div>
                                <div class="upLoad acea-row row-center-wrapper" v-else>
                                    <Icon type="ios-camera-outline" size="26" />
                                </div>
                            </el-upload>

                        </div>
                        <div class="tips">(345*345)</div>
                    </FormItem>
                    <FormItem label="等级权重" prop="weight" :rules="{required: true, message: '请选择权重'}" v-if="FromData.level_id == 'default'">
                        0
                    </FormItem>

                    <FormItem label="等级权重" prop="weight" :rules="{required: true, message: '请选择权重'}" v-else>
                        <Select placeholder="请选择"
                                v-model="FromData.weight"
                                clearable>
                            <Option :value="index" v-for="index in 30">{{index}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="一级分销比例" prop="first_money" :rules="{required: true, message: '请输入一级分销比例'}">
                        <Input type="number" v-model="FromData.first_money" :precision="1" placeholder=""></Input>
                    </FormItem>
                    <FormItem label="二级分销比例" prop="second_money" :rules="{required: true, message: '请输入二级分销比例'}">
                        <Input type="number" v-model="FromData.second_money" :precision="1" placeholder=""></Input>
                    </FormItem>
                    <FormItem label="三级分销比例" prop="third_money" :rules="{required: true, message: '请输入三级分销比例'}">
                        <Input type="number" v-model="FromData.third_money" :precision="1" placeholder=""></Input>
                    </FormItem>
                    <FormItem label="升级方式" prop="upgrade_type" :rules="{required: true, message: '请选择升级方式'}">
                        <RadioGroup element-id="is_open"  v-model="FromData.upgrade_type">
                            <Radio :label="1" class="radio">满足以下任意条件</Radio>
                            <Radio :label="2" class="radio">满足以下全部条件</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="升级条件" v-if="FromData.upgrade_condition">
                        <Row type="flex">
                            <Col span="1">
                                <i-switch v-model="FromData.upgrade_condition.self_order_num.checked" :true-value="1" :false-value="0"></i-switch>
                            </Col>
                            <Col span="23">
                                <FormItem label="自购订单总数" prop="self_order_num">
                                    <InputNumber v-model="FromData.upgrade_condition.self_order_num.num"></InputNumber><span class="ml10">单</span>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex">
                            <Col span="1">
                                <i-switch v-model="FromData.upgrade_condition.self_order_price.checked" :true-value="1" :false-value="0"></i-switch>
                            </Col>
                            <Col span="23">
                                <FormItem label="自购订单总额">
                                    <InputNumber v-model="FromData.upgrade_condition.self_order_price.num"></InputNumber><span class="ml10">元</span>
                                </FormItem>
                            </Col>

                        </Row>
                        <Row type="flex">
                            <Col span="1">
                                <i-switch v-model="FromData.upgrade_condition.first_order_num.checked" :true-value="1" :false-value="0"></i-switch>
                            </Col>
                            <Col span="23">
                                <FormItem label="一级分销订单总数">
                                    <InputNumber v-model="FromData.upgrade_condition.first_order_num.num"></InputNumber><span class="ml10">单</span>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex">
                            <Col span="1">
                                <i-switch v-model="FromData.upgrade_condition.first_order_price.checked" :true-value="1" :false-value="0"></i-switch>
                            </Col>
                            <Col span="23">
                                <FormItem label="一级分销订单总额">
                                    <InputNumber v-model="FromData.upgrade_condition.first_order_price.num"></InputNumber><span class="ml10">元</span>
                                </FormItem>
                            </Col>

                        </Row>
                        <Row type="flex">
                            <Col span="1">
                                <i-switch v-model="FromData.upgrade_condition.first_child_num.checked" :true-value="1" :false-value="0"></i-switch>
                            </Col>
                            <Col span="23">
                                <FormItem label="一级下线人数">
                                    <InputNumber v-model="FromData.upgrade_condition.first_child_num.num"></InputNumber><span class="ml10">人</span>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex">
                            <Col span="1">
                                <i-switch v-model="FromData.upgrade_condition.first_dealer_num.checked" :true-value="1" :false-value="0"></i-switch>
                            </Col>
                            <Col span="23">
                                <FormItem label="一级下线分销商">
                                    <InputNumber v-model="FromData.upgrade_condition.first_dealer_num.num"></InputNumber><span class="ml10">人</span>
                                </FormItem>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem>
                        <Button type="primary" @click="onSubmit('FromData')">提交</Button>
                    </FormItem>
                </Form>
            </Modal>
        </div>
    </div>
</template>

<script>
    import second from "../second.vue";
    export default {
        name: "index",
        components: { second },
        computed: {
            labelWidth() {
                return 80;
            },
            labelPosition() {
                return "left";
            },
        },
        data () {
            return {
                isLoad: false,
                columns: [
                    {
                        title: '等级ID',
                        slot: 'level_id'
                    },
                    {
                        title: '等级名称',
                        key: 'name'
                    },
                    {
                        title: '权重',
                        key: 'weight'
                    },
                    {
                        title: '一级分销比例 (%)',
                        key: 'first_money'
                    },
                    {
                        title: '二级分销比例 (%)',
                        key: 'second_money'
                    },
                    {
                        title: '三级分销比例 (%)',
                        key: 'third_money'
                    },
                    {
                        title: '添加时间',
                        key: 'create_time'
                    },
                    {
                        title: "操作",
                        slot: "action",
                        fixed: "right",
                        minWidth: 150,
                    }
                ],
                modals: false,
                FromData: {
                    name: '',
                    weight: '',
                    first_money: '',
                    second_money: '',
                    third_money: '',
                    upgrade_type: 1,
                    upgrade_condition: false
                },
                defalutUpgradeData: {},
                FromData_title: '',
                total: 0,
                tableData: [],
                loading: false,

                modalPic: false,
                gridPic: {
                    xl: 6,
                    lg: 8,
                    md: 12,
                    sm: 12,
                    xs: 12,
                },
                gridBtn: {
                    xl: 4,
                    lg: 8,
                    md: 8,
                    sm: 8,
                    xs: 8,
                },
            }
        },
        created() {
            this.getDefalutUpgradeData()
        },
        mounted () {
            this.getList();
        },
        methods: {
            uploadSuccess(key, model, res, file) {
                if (model == 'single') {
                    this.FromData[key] = res.data.fileInfo.external_url
                }
                this.$forceUpdate()
            },
            getDefalutUpgradeData: function () {
                var _this = this
                this.axios.post('/store/app.dealer.setting/defalutUpgradeData',{}).then(function (res) {
                    if (res.code == 1) {
                        _this.defalutUpgradeDate = res.data.upgrade
                    }
                })
            },
            // 列表
            getList () {
                this.loading = true;
                this.axios.post('/store/app.dealer.level/list', {})
                .then(async (res) => {
                    if (res.code == 1) {
                        let data = res.data.list
                        this.tableData = data;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                });
            },
            // 添加
            addLevel () {
                this.FromData_title = '新增等级'
                this.modals = true
                this.FromData = {
                    name: '',
                    weight: '',
                    first_money: '',
                    second_money: '',
                    third_money: '',
                    upgrade_type: this.defalutUpgradeDate.upgrade_type,
                    upgrade_condition: this.defalutUpgradeDate.upgrade_condition
                }
            },
            // 编辑
            edit (row) {
                this.FromData_title = '编辑等级'
                this.modals = true
                var data = JSON.parse(JSON.stringify(row))
                this.FromData = {
                    level_id: data.level_id,
                    name: data.name,
                    image_id: data.image_id,
                    image: data.image,
                    weight: data.weight,
                    first_money: data.first_money,
                    second_money: data.second_money,
                    third_money: data.third_money,
                    upgrade_type: data.upgrade_type,
                    upgrade_condition: data.upgrade_condition
                }
            },
            // 点击商品图
            modalPicTap(tit, picTit, index) {
                this.modalPic = true;
                this.isChoice = tit === "dan" ? "单选" : "多选";
                this.picTit = picTit;
                this.tableIndex = index;
            },
            // 获取单张图片信息
            getPic(pc) {
                switch (this.picTit) {
                    case "danFrom":
                        this.FromData.image = pc;
                        this.FromData.image_id = pc.file_id;
                        break;
                }
                this.modalPic = false;
            },
            // 编辑
            del (row) {
                this.$Modal.confirm({
                    title: '删除该记录',
                    content: '<p>确定要删除该记录吗？</p><p>删除后将无法恢复，请谨慎操作！</p>',
                    loading: true,
                    onOk: () => {
                        this.axios.post('/store/app.dealer.level/delete', {
                            level_id: row.level_id
                        })
                            .then(async (res) => {
                                if (res.code == 1) {
                                    this.$Modal.remove();
                                    this.$Message.success(res.msg);
                                    this.getList()
                                } else {
                                    this.$Message.error(res.msg);
                                    this.$Modal.remove();
                                }
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                })
            },
            cancel: function () {
                this.modals = false
                this.FromData = null
            },
            onSubmit: function (name) {
                var _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var upgrade_condition = this.FromData.upgrade_condition
                        for (var i in upgrade_condition) {
                            if (upgrade_condition[i].checked && upgrade_condition[i].num <= 0) {
                                _this.$Message.error('选择的升级条件不能为0')
                                return false;
                            }
                        }

                        if (this.FromData.level_id) {
                            var form = JSON.parse(JSON.stringify(this.FromData));
                            var level_id = form.level_id
                            delete form.level_id
                            this.axios.post('/store/app.dealer.level/edit', {
                                level_id: level_id,
                                form: form
                            })
                                .then((res) => {
                                    if (res.code == 1) {
                                        _this.$Message.success(res.msg)
                                        _this.getList()
                                        // 关闭对话框事件
                                        _this.cancel()
                                    } else {
                                        _this.$Message.error(res.msg)
                                    }
                                })
                        } else {
                            this.axios.post('/store/app.dealer.level/add', { form: this.FromData })
                                .then((res) => {
                                    if (res.code == 1) {
                                        _this.$Message.success(res.msg)
                                        _this.getList()
                                        // 关闭对话框事件
                                        _this.cancel()
                                    } else {
                                        _this.$Message.error(res.msg)
                                    }
                                })
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
